/**
 * src/components/admin/AdminLogin.js
 *
 * Pantalla de login del panel admin.
 * La contraseña se configura aquí (solo protección básica para
 * una herramienta de edición de JSON, no para datos sensibles).
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

const ADMIN_PASSWORD = 'ubiyaaa2026'  // ← cambia esto

define('AdminLogin', ({ onSuccess }) => {
    /* Elementos con referencia directa (no usar querySelector con dataset:
       el h() de Flexy no soporta el atributo dataset) */
    const input = h('input', {
        className:    'adm-input',
        type:         'password',
        placeholder:  'Contraseña',
        autocomplete: 'current-password',
        name:         'pwd'
    })

    const error = h('div', { className: 'admin-login__error' },
        '❌ Contraseña incorrecta'
    )

    const form = h('form', { className: 'admin-login__form' },
        input,
        error,
        h('button', {
            className: 'adm-btn adm-btn--primary',
            type: 'submit',
            style: 'width:100%;justify-content:center;padding:.65rem'
        }, '🔐 Entrar')
    )

    form.addEventListener('submit', e => {
        e.preventDefault()
        if (input.value === ADMIN_PASSWORD) {
            sessionStorage.setItem('admin-auth', '1')
            onSuccess?.()
        } else {
            error.classList.add('visible')
            input.value = ''
            input.focus()
            setTimeout(() => error.classList.remove('visible'), 3000)
        }
    })

    return h('div', { className: 'admin-login' },
        h('div', { className: 'admin-login__card' },
            h('div', { className: 'admin-login__logo' }, 'UBIYAAA'),
            h('p',   { className: 'admin-login__sub'  }, 'Panel de administración'),
            form
        )
    )
})
